import { BUTTON_TYPES } from 'src/models/page/Section'
/**
 * This mixin is used to create Site Locations List components that share Site Selector Related Component.
 */
export default {
  configuration: ['sites', 'currentSite'],
  computed: {
    locationZones () {
      if (this.flattenZoneGroups) return []
      return _.filter(this.siteLocationZones.data, locationZone => locationZone.visibleSites.length > 0)
    },
    sitesWithoutLocationZoneId () {
      if (this.flattenZoneGroups) return this.siteLocations
      const locationZoneSites = _.flatten(_.map(this.siteLocationZones.data, locationZone => locationZone.siteIds))
      return _.filter(this.sites.data, site => !site.isLibrary && !site.siteLocationZoneId && !site.consumerConfig.hideOnLocationSelectPage && !_.includes(locationZoneSites, site.id))
    },
    siteLocations () {
      const siteLocations = _.filter(this.sites.data, site => !site.isLibrary && !site.consumerConfig.hideOnLocationSelectPage)
      return _.sortBy(siteLocations, site => site.displayOrder)
    },
    allSitesHaveImages () {
      return _.every(this.siteLocations, site => site.siteThumbnailImageUrl)
    }
  },
  models: {
    siteLocationZones: {
      sites: 'default'
    }
  },
  methods: {
    getClasses (button, color, colorHex) {
      const classes = []

      // Handle STANDARD and UNELEVATED button types
      if (button === BUTTON_TYPES.STANDARD || button === BUTTON_TYPES.UNELEVATED) {
        if (color === 'default') {
          classes.push('text-grey')
        } else if (color !== 'custom') {
          classes.push(`bg-${color}`)
          classes.push(this.$getTextColor(this.currentSite, color))
        } else if (color === 'custom' && colorHex) {
          classes.push(this.$isColorDark(colorHex) ? 'text-white' : 'text-black')
        }
      }

      // Handle FLAT and OUTLINE button types
      if (button === BUTTON_TYPES.FLAT || button === BUTTON_TYPES.OUTLINE) {
        if (color !== 'custom') {
          classes.push(`text-${color}`)
        }
      }

      return classes.join(' ')
    },
    getStyles (button, color, colorHex, borderRadius) {
      const styles = []

      if (borderRadius !== null) {
        styles.push(`border-radius: ${borderRadius}px`)
      }
      if ((button === BUTTON_TYPES.STANDARD || button === BUTTON_TYPES.UNELEVATED) && color === 'custom') {
        styles.push(`background-color: ${colorHex}`)
      }
      if ((button === BUTTON_TYPES.FLAT || button === BUTTON_TYPES.OUTLINE) && color === 'custom') {
        styles.push(`color: ${colorHex}`)
      }

      return styles.join(';')
    }
  }
}
